import { ITableCell } from '../Table.types';
import classes from './TableCell.module.css';

export const TableCell = (props: ITableCell) => {
    const { children, align = 'left', width, minWidth, isSelected, showMarker } = props;

    const style: React.CSSProperties = {
        fontWeight: isSelected ? '700' : '400',
        textAlign: align,
        ...(width && { width }),
        ...(minWidth && { minWidth }),
    };

    return (
        <td className={`${classes.tableCell} ${isSelected ? classes.selected : ''}`} style={style}>
            <div className={classes.contentContainer}>
                {showMarker && (
                    <div className={`${classes.marker} ${showMarker ? classes.show : ''}`} />
                )}
                {children}
            </div>
        </td>
    );
};
